import {
  deletePermission,
  getAllPermission,
  getPermissionById,
  pagingPermission,
  saveOrUpdate,
} from "app/services/PermissionService";
import { makeAutoObservable } from "mobx";

import { checkSearchObject } from "app/common/LocalFunction";
import { Permission } from "app/common/Model/Permission";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";

export default class PermissionStore {
  listAllPermission = [];
  searchPermission = new SearchObject();
  pagePermission = null;
  selectedPermission = null;
  openFormCreateOrEdit = false;
  openConfirmDelete = false;
  recentlyUpdated = false;

  constructor() {
    makeAutoObservable(this);
  }

  getAllPermission = async () => {
    if (this.listAllPermission?.length === 0 || this.recentlyUpdated) {
      getAllPermission()
        .then(({ data }) => {
          this.listAllPermission = data;
          this.recentlyUpdated = false;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    }
  };

  pagingPermission = async () => {
    return await pagingPermission(this.searchPermission)
      .then(({ data }) => {
        this.pagePermission = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleChangeFormSearch = (searchPermission) => {
    this.searchPermission = checkSearchObject(
      this.searchPermission,
      searchPermission
    );
    this.pagingPermission();
  };

  handleOpenFormCreateOrEdit = (permissionId) => {
    if (Boolean(permissionId)) {
      getPermissionById(permissionId).then(({ data }) => {
        this.selectedPermission = data;
        this.openFormCreateOrEdit = true;
      });
    } else {
      this.selectedPermission = new Permission();
      this.openFormCreateOrEdit = true;
    }
  };

  saveOrUpdatePermission = (permission, { setSubmitting }) => {
    saveOrUpdate(permission)
      .then(({ data }) => {
        this.selectedPermission = null;
        if (data) {
          toast.success("Lưu dữ liệu thành công!");
        }
        this.handleClosePopup();
        this.pagingPermission();
        this.recentlyUpdated = true;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu dữ liệu có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleDelete = (permission) => {
    this.selectedPermission = { id: permission?.id };
    this.openConfirmDelete = true;
  };

  handleConfirmDelete = async () => {
    return await deletePermission(this.selectedPermission?.id)
      .then(() => {
        if (
          this.searchPermission?.pageIndex > 1 &&
          this.pagePermission?.content?.length === 1
        ) {
          this.searchPermission.pageIndex -= 1;
        }
        toast.success("Xóa bản ghi thành công!");
        this.handleClosePopup();
        this.pagingPermission();
        this.recentlyUpdated = true;
      })
      .catch((err) => {
        console.error(err);
        toast.error("Xóa bản ghi có lỗi");
      });
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDelete = false;
  };

  resetStore = () => {
    this.searchPermission = new SearchObject();
    this.pagePermission = null;
    this.selectedPermission = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDelete = false;
  };

  //for choosing permission popup in ChoosePermissionPopup.jsx
  listPermission = [];
  permissionIdSet = null;

  isValidPermission = (permission) => {
    if (permission && permission?.id) return true;
    console.error("Invalid manipulated element");
    return false;
  };

  addPermission = (permission) => {
    if (!this.isValidPermission(permission)) return;
    this.listPermission.push(permission);
    this.permissionIdSet.add(permission?.id);
  };

  initializeListPermission = (permissions) => {
    this.permissionIdSet = new Set();
    this.listPermission = [];
    if (permissions && permissions?.length > 0) {
      for (let i = 0; i < permissions.length; i++) {
        this.addPermission(permissions[i]);
      }
    }
  };

  removePermission = (permission) => {
    if (!this.isValidPermission(permission)) return;
    if (this.permissionIdSet.has(permission?.id)) {
      this.permissionIdSet.delete(permission?.id);
    } else {
      console.error("Element is not exist");
    }
  };

  isExist = (permission) => {
    if (!this.isValidPermission(permission)) return;
    return this.permissionIdSet.has(permission?.id);
  };

  getPermissionIdSet = () => {
    return this.permissionIdSet;
  };

  getListPermission = () => {
    const bufferIdSet = new Set();
    const data = [];
    if (this.listPermission && this.listPermission?.length > 0) {
      for (let i = 0; i < this.listPermission.length; i++) {
        const permission = this.listPermission[i];
        if (this.isExist(permission) && !bufferIdSet.has(permission?.id)) {
          data.push(permission);
          bufferIdSet.add(permission?.id);
        }
      }
    }
    this.listPermission = data;
    return data;
  };
  //end
}
